<template>
  <div class="main">
    <div class="form">
      <van-form @submit="onSubmit">
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          申请人信息
        </van-divider>
        <van-field readonly clickable v-model="formItem.type" required name="类型" :value="formItem.type" label="类型"
          placeholder="点击选择类型" @click="showPicker = true" />
        <van-field v-if="formItem.type === '个人'" required v-model="formItem.name" name="用户名" label="申请人姓名"
          placeholder="请输入您的真实姓名" :rules="[{ required: true, message: '请填写申请人姓名' }]" />
        <van-field v-else v-model="formItem.name" required name="用户名" label="单位名称" placeholder="请输入单位名称"
          :rules="[{ required: true, message: '请输入单位名称' }]" />
        <van-field required v-if="formItem.type === '公司'" name="uploaderIdCard">
          <template #input>
            <van-uploader max-count="1" upload-text="上传授权委托书"
              :upload-icon="require('../../../public/static/image/weatherCertificate/authorize_file.png')"
              v-model="authorizeFile" :after-read="uploadAuthorizeFile"></van-uploader>
          </template>
        </van-field>

        <van-field required v-model="formItem.id_card" name="身份证号" label="身份证号" placeholder="请输入您的身份证号"
          :rules="[{ required: true, message: '请填写身份证号' }]" />

        <van-field required name="uploaderIdCard">
          <template #input>
            <van-uploader max-count="1" upload-text="上传身份证正面"
              :upload-icon="require('../../../public/static/image/weatherCertificate/id_card_front.png')"
              v-model="idCardFrontImage" :after-read="uploadIDcardFront"></van-uploader>

            <van-uploader max-count="1" upload-text="上传身份证反面"
              :upload-icon="require('../../../public/static/image/weatherCertificate/id_card_back.png')"
              v-model="idCardBackImage" :after-read="uploadIDcardBack"></van-uploader>
          </template>
        </van-field>
        <van-field required v-model="formItem.phone" name="手机号码" label="手机号码" placeholder="请输入您的手机号码"
          :rules="[{ required: true, message: '请填写手机号码' }]" />


        <van-field readonly required clickable name="area" :value="formItem.area" label="地区选择" placeholder="点击选择省市区"
          @click="showArea = true" />

        <van-field required v-model="formItem.address" name="详细地址" label="详细地址" placeholder="请输入您的详细地址"
          :rules="[{ required: true, message: '请填写详细地址' }]" />

        <van-field v-model="formItem.remark" name="备注" label="备注" placeholder="请输入备注" />
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          申请内容
        </van-divider>
        <van-field readonly clickable v-model="formItem.purpose" required name="申请用途" :value="formItem.purpose"
          label="申请用途" placeholder="点击选择用途" @click="showPruposePicker = true" />

        <van-field name="checkboxGroup" required label="气象要素">
          <template #input>
            <van-checkbox-group v-model="elements" direction="horizontal">
              <van-checkbox name="气温" shape="square">气温</van-checkbox>
              <van-checkbox name="降水" shape="square">降水</van-checkbox>
              <van-checkbox name="极大风速" shape="square">极大风速</van-checkbox>
              <!-- <van-checkbox name="其他" shape="square">其他</van-checkbox> -->
            </van-checkbox-group>
          </template>
        </van-field>

        <van-field readonly clickable required name="begin_time" :value="formItem.begin_time" label="开始日期"
          placeholder="点击选择开始日期" @click="showBeginTimeCalendar = true" />
        <van-calendar v-model="showBeginTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
          @confirm="onBeginTimeConfirm" />

        <van-field readonly clickable required name="end_time" :value="formItem.end_time" label="结束日期"
          placeholder="点击选择结束日期" @click="showEndTimeCalendar = true" />
        <van-calendar v-model="showEndTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
          @confirm="onEndTimeConfirm" />

        <van-field v-model="formItem.illustrate" rows="2" autosize label="补充说明" type="textarea" maxlength="50"
          placeholder="请输入补充说明" show-word-limit />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="types" @confirm="onConfirm" @cancel="showPicker = false"
            :default-index="0" />
        </van-popup>
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea = false" />
        </van-popup>
        <van-popup v-model="showPruposePicker" position="bottom">
          <van-picker show-toolbar :columns="purposes" @confirm="onPruposeConfirm" @cancel="showPruposePicker = false"
            :default-index="0" />
        </van-popup>
      </van-form>
    </div>

  </div>
</template>
<script>
import MyCertificate from './MyCertificate.vue'
import { Toast } from 'vant';
import Vue from "vue";
import requestForm from '@/utils/requestForm.ts'
import request from '@/utils/request.ts'
import config from '@/utils/config'
export default Vue.extend({
  components: {
    MyCertificate
  },
  mounted() {
    this.formItem.open_id =  this.$store.state.current.id
    // this.formItem.open_id = this.$store.state.openId
    if (!this.formItem.open_id) {
      this.formItem.open_id = 'test'
    }
  },
  data() {
    return {
      showPicker: false,
      showArea: false,
      showPruposePicker: false,
      showBeginTimeCalendar: false,
      showEndTimeCalendar: false,
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(),
      types: ['个人', '公司'],
      purposes: ['保险理赔', '司法取证', '其他'],
      areaList: {
        province_list: {
          610000: '陕西省',
        },
        city_list: {
          610500: '渭南市',
        },
        county_list: {
          610118: '大荔县',
        },
      },
      data: {},
      fileUrl: config.fileUrl,
      formItem: {
        type: '个人',
        name: '',
        authorize_file: '',
        open_id: '',
        phone: '',
        id_card: '',
        id_card_front: '',
        id_card_back: '',
        area: '陕西省/渭南市/大荔县',
        address: '',
        purpose: '报销理赔',
        element: '',
        begin_time: '',
        end_time: '',
        illustrate: '',
        remark: '',
      },
      idCardFrontImage: [],
      idCardBackImage: [],
      authorizeFile: [],
      elements: ['气温', '降水'],
    }
  },
  methods: {
    onConfirm(value, index) {
      this.formItem.type = value
      this.showPicker = false
    },
    onChange(picker, value, index) {
      this.formItem.type = value
    },
    onAreaConfirm(values) {
      console.log(values)
      this.formItem.area = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      console.log(this.formItem.area)
      this.showArea = false;
    },
    onPruposeConfirm(value) {
      this.formItem.purpose = value
      this.showPruposePicker = false
    },
    onBeginTimeConfirm(date) {
      console.log(date)
      this.formItem.begin_time = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showBeginTimeCalendar = false;
    },
    onEndTimeConfirm(date) {
      this.formItem.end_time = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showEndTimeCalendar = false;
    },

    uploadIDcardFront(fileItme) {
      fileItme.status = 'uploading';
      fileItme.message = '上传中...';
      const getFile = fileItme.file
      const that = this
      const params = { filePath: 'cert', file: fileItme.file }
      let fileForm = new FormData();
      for (let key in params) {
        //*
        fileForm.append(key, params[key]);
      }
        requestForm.formPost('/api/column/file/upload', fileForm).then((res) => {
          if (res) {
            fileItme.status = 'success';
            that.formItem.id_card_front = that.fileUrl + res
          } else {
            fileItme.status = 'failed';
            fileItme.message = '上传失败';
          }
        })
      },
      uploadIDcardBack(fileItme) {
        fileItme.status = 'uploading';
        fileItme.message = '上传中...';
        const getFile = fileItme.file
        const that = this
        const params = { filePath: 'cert', file: fileItme.file }
        let fileForm = new FormData();
        for (let key in params) {
          //*
          fileForm.append(key, params[key]);
        }
        requestForm.formPost('/api/column/file/upload', fileForm).then((res) => {
          if (res) {
            fileItme.status = 'success';
            that.formItem.id_card_back = that.fileUrl + res
          } else {
            fileItme.status = 'failed';
            fileItme.message = '上传失败';
          }
        })
      },
      uploadAuthorizeFile(fileItme) {
        fileItme.status = 'uploading';
        fileItme.message = '上传中...';
        const getFile = fileItme.file
        const that = this
        const params = { filePath: 'cert', file: fileItme.file }
        let fileForm = new FormData();
        for (let key in params) {
          //*
          fileForm.append(key, params[key]);
        }
        requestForm.formPost('/api/column/file/upload', fileForm).then((res) => {
          if (res) {
            fileItme.status = 'success';
            that.formItem.authorize_file = that.fileUrl + res
          } else {
            fileItme.status = 'failed';
            fileItme.message = '上传失败';
          }
        })
      },
      onSubmit() {
        const params = this.formItem
        params.element = this.elements.join(',')
        if (this.formItem.type === '公司') {
          if (!this.formItem.authorize_file) {
            Toast.fail('请上传授权文件');
            return
          }
        }
        if (!this.formItem.id_card_front) {
          Toast.fail('请上传身份证正面照片');
          return
        }
        if (!this.formItem.id_card_back) {
          Toast.fail('请上传身份证反面照片');
          return
        }
        // this.$refs.dataForm.validate((valid) => {
        // if (valid) {
        request.post('/wechat_serve/weather_cert', params)
          .then((res) => {
            console.log(res)
            Toast.success('申请成功')
            this.$router.push('/weather_certificate/apply_result')
          })
        // }
        // })
      }
    }
  })
</script>

<style scoped lang="scss">
.main {
  height: 100vh;
  width: 100vw;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px;
}

::v-deep .van-uploader__upload,
::v-deep .van-image,
::v-deep .van-uploader__preview-image {
  width: 40vw;
  height: 110px;
}

::v-deep .van-uploader__upload-text {
  margin-top: 8px;
  color: #969799;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #1da4f2;
  color: #fff;
  text-align: center;
}

::v-deep .van-uploader__upload,
::v-deep .van-image {
  background: #E8F6FE;
  border-radius: 10px;
  overflow: hidden;
}

::v-deep .van-icon__image {
  width: 4em;
  height: 3em;
  -o-object-fit: contain;
  object-fit: contain;
  margin-bottom: 23px;
}
</style>
